module.exports = __webpack_public_path__ + "files/a14eebbff542b4dc4834b7fe8019d40f.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/organization.png
// module id = 935
// module chunks = 76